import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "../../../../../../../redux/store";
import type { SubmittedToFunderFundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { TRAINING_ITEM_TYPE } from "@academy-context/shared/domain/types/training-items";

export const retrieveSubmittedToFunderFundingRequests = createAsyncThunk<
  SubmittedToFunderFundingRequestVM[],
  { funders: string[]; trainingItemTypes?: TRAINING_ITEM_TYPE[] } | undefined,
  { extra: Partial<Dependencies> }
>(
  "fundingRequests/retrieveSubmittedToFunderFundingRequests",
  async (filters: { funders: string[]; trainingItemTypes?: TRAINING_ITEM_TYPE[] } | undefined, { extra: { adminRepository } }) => {
    const requests = await adminRepository!.getAll({
      status: ["submitted_to_funder"],
      funders: filters?.funders,
      trainingItemTypes: filters?.trainingItemTypes,
    });
    const response: SubmittedToFunderFundingRequestVM[] = [];
    for (const r of requests) {
      if (r.status === "submitted_to_funder") {
        response.push(r);
      }
    }
    return response;
  },
);
